import { API_URL } from "../../../constants";
import { OrganizationMember } from "../../../dashboard/saas/Settings/types";
import * as httpNetworking from "../../../httpNetworking";

const URL = API_URL + "/organization/member/list";
const VERSION = 0;
export type OrganizationMembersResponse =
    | { organizationFound: false }
    | {
          organizationFound: true;
          organizationId: string;
          organizationName: string;
          timeCreated: number;
          members: OrganizationMember[];
      };

export async function getOrganizationMembers(): Promise<OrganizationMembersResponse> {
    let options: httpNetworking.GETRequestConfig = {
        timeout: 50000
    };

    let result = (await httpNetworking.simpleGETRequest(URL, options, VERSION)).data;
    return result;
}
